import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable } from 'rxjs'

import { AuthService } from '_sdk'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check access token
    if (this.authService.getAccessTokenKey()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getAccessTokenKey()}`,
        },
      })
    }

    return next.handle(request)
  }
}
